import { Component, Input, ViewEncapsulation } from '@angular/core';
import { SubscriptionModel } from '../../../../shared/models/subscription.model';
import { PaymentMethodModel } from '../../../../shared/models/payment-method.model';
import { ClientModel } from '../../../../shared/models/client.model';

@Component({
    selector: 'account-subscriptions-details-payment-data',
    templateUrl: './account.subscriptions.details.payment-data.component.html',
    styleUrls: ['./../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSubscriptionsDetailsPaymentDataComponent {
    @Input('subscription') subscription: SubscriptionModel;
    @Input('client') client: ClientModel;
    @Input('isActive') isActive: boolean;
    public updating = false;

    /**
     * Check if payment method type is card.
     *
     * @return bool
     **/
    public isCard(paymentMethod: PaymentMethodModel) {
        return paymentMethod.type === 'credit card'
            || paymentMethod.type === 'debit card';
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2032928750/src/src/app/account/subscriptions/details/payment-data/account.subscriptions.details.payment-data.component.ts